import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { push } from 'connected-react-router'

import { useDispatch, useSelector } from 'react-redux'
import * as CompanyActions from '@redux/onboarding/company-step/company-step-action'
import * as PlanActions from '@redux/plan/plan-action'
import * as PlanSelector from '@selectors/plan/plan-selector'
import * as OnboardingSelector from 'selectors/onboarding/onboarding-selector'
import * as RequestingSelector from '@selectors/requesting/requesting-selector'

import TemplateStep from '@components/layout/template-step'
import InputText from '@components/input/input-text/input-text'
import InputCNPJ from '@components/input/input-cnpj/input-cnpj'
import InputUrl from '@components/input/input-url/input-url'
import Dropdownlist from '@components/input/dropdownlist/dropdownlist'
import ToggleSwitch from '@components/toggle-switch/toggle-switch'
import Dropzone from '@components/dropzone/dropzone'
import { CompanyPageStyles } from './company-style'

import ModalValidation from './components/modal-validation/modal-validation'
import ModalRegulation from './components/modal-regulation/modal-regulation'
import RouteEnum from '@constants/RouteEnum'
import Header from '@components/layout/header'
import Loader from '@components/loader/loader'

const CompanyStep = ({ match }) => {
  const dispatch = useDispatch()

  const company = useSelector(OnboardingSelector.company)
  const companyExits = useSelector(OnboardingSelector.companyExits)
  const planExists = useSelector(PlanSelector.planExists)
  const categoryList = useSelector(OnboardingSelector.categoryList)

  const isLoadingVerifyExistsPlan = useSelector(state => RequestingSelector.selectRequesting(state, [PlanActions.REQUEST_VERIFY_EXISTS_PLAN]))
  const isLoadingVerifyExistsPlanFinished = useSelector(state =>
    RequestingSelector.selectRequesting(state, [PlanActions.REQUEST_VERIFY_EXISTS_PLAN_FINISHED])
  )

  const [cnpjIsloading, setCnpjIsloading] = useState(false)
  const [isVirtualStore, setIsVirtualStore] = useState(company.virtualStore)
  const [isOpenedRegulation, setIsOpenedRegulation] = useState(false)

  const OptinLabel = () => (
    <>
      Aceito os <a onClick={handleModalRegulation}>termos</a> e condições legais
    </>
  )

  const handleImage = (file, fileName) => {
    dispatch(CompanyActions.setCompanyField('brand', file))
    dispatch(CompanyActions.setCompanyField('fileName', fileName))
  }
  const handleChange = ({ name, value }) => {
    dispatch(CompanyActions.setCompanyField(name, value))
  }
  const handleSelectChange = value => {
    dispatch(CompanyActions.setCompanyField('category', value))
  }
  const handleCheckboxChange = ({ name, checked }) => {
    switch (name) {
      case 'physicalStore':
        dispatch(CompanyActions.setCompanyField(name, !company.physicalStore))
        break
      case 'virtualStore':
        dispatch(CompanyActions.setCompanyField(name, !company.virtualStore))
        setIsVirtualStore(!company.virtualStore)
        break
      case 'optinRegulation':
        dispatch(CompanyActions.setCompanyField(name, !company.optinRegulation))
        break
      default:
        console.clear()
        console.log('Não encontrado nenhum campo:', { value: value, id: id, name: name, checked: checked })
    }
  }

  const handleModalRegulation = () => setIsOpenedRegulation(!isOpenedRegulation)

  const checkExistingUser = value => {
    setCnpjIsloading(true)
    const partnerId = 0
    if (value && value.length === 14) {
      dispatch(CompanyActions.verifyCompany(value, partnerId))
    }
    setCnpjIsloading(false)
  }

  useEffect(() => {
    dispatch(PlanActions.verifyExists(match?.params?.planId))
    dispatch(CompanyActions.getCategories())
    dispatch(CompanyActions.getCurrentAcceptanceTerms())
  }, [])

  useEffect(() => {
    if (!planExists && isLoadingVerifyExistsPlanFinished) dispatch(push(RouteEnum.DefaultPlan))
  }, [planExists, isLoadingVerifyExistsPlanFinished])

  return (
    <Loader isLoading={(isLoadingVerifyExistsPlan || !isLoadingVerifyExistsPlanFinished) && !planExists}>
      <TemplateStep externalValidations={[!company.physicalStore && !company.virtualStore]}>
        <CompanyPageStyles />
        <div className="row">
          <div className="col-12 col-sm-6">
            <InputCNPJ
              name="cnpj"
              value={company.cnpj}
              loading={cnpjIsloading}
              onChange={handleChange}
              onBlur={checkExistingUser}
              fixedLabel
              label="CNPJ"
              required
            />
          </div>
          <div className="col-12 col-sm-6">
            <InputText name="companyName" value={company.companyName} onChange={handleChange} fixedLabel label="Razão Social" required />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-sm-6">
            <InputText name="companyAlias" value={company.companyAlias} onChange={handleChange} fixedLabel label="Nome Fantasia" required />
          </div>
          <div className="col-12 col-sm-6">
            <Dropdownlist name="category" options={categoryList} value={company.category} onChange={handleSelectChange} label={'Categoria'} />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6 py-0">
            <Dropzone id="brand" label="Logomarca" textIntro="Adicione sua logomarca" value={company.brand} onChange={handleImage} />
          </div>
          <div className="col-12 col-sm-6 py-0 bx-checks">
            <div className="py-5">
              <ToggleSwitch
                name="physicalStore"
                checked={company.physicalStore}
                value={company.physicalStore}
                onChange={handleCheckboxChange}
                label="Possui loja física?"
              />
            </div>
            <div className="py-5">
              <ToggleSwitch
                name="virtualStore"
                checked={company.virtualStore}
                value={company.virtualStore}
                onChange={handleCheckboxChange}
                label="Possui loja virtual?"
              />
              <InputUrl
                name="virtualStoreAddress"
                className={classNames('field-url', { active: isVirtualStore })}
                value={company.virtualStoreAddress}
                onChange={handleChange}
                id="loja-virtual"
                noLabel
                placeholder="ex: www.sualoja.com.br"
                required={isVirtualStore}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 py-5">
            <ToggleSwitch
              required
              name="optinRegulation"
              value={company.optinRegulation}
              checked={company.optinRegulation}
              onChange={handleCheckboxChange}
              customLabel={<OptinLabel />}
            />
          </div>
        </div>

        <ModalValidation isOpened={companyExits} />
        <ModalRegulation isOpened={isOpenedRegulation} onClose={handleModalRegulation} />
      </TemplateStep>
    </Loader>
  )
}

CompanyStep.displayName = 'CompanyStep_Page'

export default CompanyStep
